import "./Boimela.css";

const readingAppModules = [
  "User authentication and profiles",
  "Library catalog and search",
  "Book details and metadata",
  "Categories and genres",
  "eBook reader (fonts, themes, bookmarks)",
  "Audiobook player",
  "Continue reading and history",
  "Favorites and wishlist",
  "Downloads and offline access",
  "Ratings and reviews",
  "Author and publisher profiles",
  "Notifications and announcements",
  "Offers and promotions",
  "Admin dashboard for content and users",
  "Analytics and reporting",
  "Payment and subscription setup",
];

export const Boimela = () => {
  return (
    <section className="boimela" id="boimela">
      <div className="boimela__hero">
        <p className="boimela__eyebrow">Boighor to Boimela</p>
        <h1 className="boimela__title">Boimela Digital Library</h1>
        <p className="boimela__subtitle">
          Boighor is offering you the largest library of Bengali books of all
          times and genres, captivating audio-books, and the best of English
          classics with the smartest and simplest UI design for your utmost eBook
          reading experience.
        </p>
      </div>

      <div className="boimela__content">
        <article className="boimela__card boimela__card--features">
          <h2 className="boimela__card-title">Module Breakdown</h2>
          <ul className="boimela__list">
            {readingAppModules.map((item) => (
              <li key={item}>{item}</li>
            ))}
          </ul>
        </article>

        <article className="boimela__card boimela__card--budget">
          <div className="boimela__budget-head">
            <div>
              <p className="boimela__card-label">Package Budget</p>
              <h2 className="boimela__card-title">Module-wise Estimation</h2>
            </div>
            <div className="boimela__price">
              <span className="boimela__price-value">60,000</span>
              <span className="boimela__price-text">BDT</span>
            </div>
          </div>
          <div className="boimela__meta">
            <div className="boimela__timeline">
              <span className="boimela__timeline-label">Timeline</span>
              <span className="boimela__timeline-value">20 days</span>
            </div>
            <div className="boimela__stack">
              <span className="boimela__stack-label">Stack</span>
              <div className="boimela__stack-tags">
                <span>Android and iOS with Flutter</span>
                <span>Website and admin frontend with React JS</span>
                <span>Backend and API with Laravel</span>
              </div>
            </div>
          </div>
          <p className="boimela__budget-note">
            One package includes all modules listed below.
          </p>
          <ul className="boimela__list">
            {readingAppModules.map((item) => (
              <li key={item}>{item}</li>
            ))}
          </ul>
        </article>
      </div>
    </section>
  );
};
